import React, {useEffect} from 'react';
import { Routes,Route, Link } from "react-router-dom"; 
import { useSelector, useDispatch } from 'react-redux';
import './App.css';
import {Container} from './scss/theme';
import Navbar from './Navbar';


import MainPage from './page_home/MainPage.js';

import Login1_where from './page_login/Login1_where.js';

//------------------------------------------------------------

import usePreventRefresh from './comm/usePreventRefresh';

import AutoLogout from './comm/AutoLogout';

import MainPage_first from './page_home/MainPage_first.js';
import SignUp_aca from './page_login/SignUp_aca.js';
import SignUp_school from './page_login/SignUp_school.js';
import SignUp_individual from './page_login/SignUp_individual.js';
import Assessment from './page_assessment/AssessApp.js';

import MyRoom_aca from './page_myRoom/MyRoom_aca.js';
import RegAcaTec from './page_regTec/RegAcaTec.js';

import MyRoom_acaTec from './page_myRoom/MyRoom_acaTec.js';
import RegAcaStu from './page_regTec/RegAcaStu.js';
import MyRoom_acaStu from './page_myRoom/MyRoom_acaStu.js';
//---------------------------------------------------------학교
import MyRoom_sch from './page_myRoom/MyRoom_sch.js';
import RegSchTec from './page_regTec/RegSchTec.js';
import MyRoom_schTec from './page_myRoom/MyRoom_schTec.js';
import RegSchStu from './page_regTec/RegSchStu.js';
import MyRoom_schStu from './page_myRoom/MyRoom_schStu.js';

import MyRoom_mom from './page_myRoom/MyRoom_mom.js';
import RegMomStu from './page_regTec/RegMomStu.js';
import MyRoom_momStu from './page_myRoom/MyRoom_momStu.js';

import Assess_all_testNmApp from './page_assessment/Assess_all_testNmApp.js';
// import Assess_all_testNmApp_link from './page_assessment/Assess_all_testNmApp_link.js';

import Assess_all_marking from './page_assessment/Assess_all_marking.js';
import Assess_all_marking_stu from './page_assessment/Assess_all_marking_stu.js';
import Assess_all_marking_stu_link from './page_assessment/Assess_all_marking_stu_link.js';
import Assess_link_stu from './page_assessment/Assess_link_stu.js'; 


import Example from './page_chart/Example.js';
import Example2 from './page_chart/Example2.js';

import IongChartApp from './page_chart/IongChartApp.js';

import Assess_etc_app from './page_assessment_ect/Assess_etc_app.js';
import Assess_etc_checkList_nm from './page_assessment_ect/Assess_etc_checkList_nm.js';
import Assess_book_app from './page_assessment_ect/Assess_book_app.js';
import Assess_book_checkList_nm from './page_assessment_ect/Assess_book_checkList_nm.js';
import VideoEdu from './page_videoEdu/VideoEdu.js';
import VideoEdu_stu from './page_videoEdu/VideoEdu_stu.js';
import Adminsions_consultant from './page_contract/Admissions_consultant.js';

//-------------------------------------------------------------------------admin
import Ad_adminsions_consultant_app from './page_admin/page_contract/Ad_admissions_consultant_app.js';
import Ad_login from './page_admin/page_login/Ad_login.js';
import Ad_menu from './page_admin/page_menu/Ad_menu.js';

import Ujab_write from './page_ujab/Ujab_write.js';
import Ujab_detail from './page_ujab/Ujab_detail.js';
import Ujab_board from './page_ujab/Ujab_board.js';

function App() {
  const isStudent = useSelector(state => state.reduxStore.isStudent); 
  const isLoggedIn = useSelector(state => state.reduxStore.isLoggedIn); 
  const dispatch = useDispatch();
  
  usePreventRefresh();//새로고침 경고

    //-------------------------------------------------------------최신 업데이트
    useEffect(() => {

      const currentVersion = localStorage.getItem('updateVersion');
      const newVersion = '1.0.1';
  
      if (currentVersion !== newVersion) {
        localStorage.setItem('updateVersion', newVersion); 
        window.location.reload(true); // 강제 새로고침, 사파리는 어떤지 확인 필요
      }
    }, []);

  //==================================================================
  return (
    <div className="App">
   
     {<Navbar /> }
      <Container>
      <AutoLogout timeout={15*60*1000} /> {/* 5분 후 자동 로그아웃 */}
      <Routes> 

      {/* <Route path="/" element={<Login/>}/> */}
      <Route path="/" element={<MainPage_first/>}/>
      <Route path="/main" element={<MainPage/>}/>
      <Route path="/loginWhere" element={<Login1_where/>}/>
      <Route path="/signupAca" element={<SignUp_aca/>}/>
      <Route path="/signupSchool" element={<SignUp_school/>}/>
      <Route path="/signupIndividual" element={<SignUp_individual/>}/>

      <Route path="/assessment" element={<Assessment/>}/>
      
      <Route path="/myRoomAca" element={<MyRoom_aca/>}/>
      <Route path="/regAcaTec" element={<RegAcaTec/>}/>
      
      <Route path="/myRoomAcaTec" element={<MyRoom_acaTec/>}/>
      <Route path="/regAcaStu" element={<RegAcaStu/>}/>
      <Route path="/myRoomAcaStu" element={<MyRoom_acaStu/>}/>
      {/* ----------------------------------------------학교 */}
      <Route path="/myRoomSch" element={<MyRoom_sch/>}/>
      <Route path="/regSchTec" element={<RegSchTec/>}/>

      <Route path="/myRoomSchTec" element={<MyRoom_schTec/>}/>
      <Route path="/regSchStu" element={<RegSchStu/>}/>
      <Route path="/myRoomSchStu" element={<MyRoom_schStu/>}/>

      <Route path="/myRoomMom" element={<MyRoom_mom/>}/>
      <Route path="/regMomStu" element={<RegMomStu/>}/>
      <Route path="/myRoomMomStu" element={<MyRoom_momStu/>}/>

      <Route path="/assess/all/testNmApp" element={<Assess_all_testNmApp/>}/>
      {/* <Route path="/assess/all/testNmApp_link" element={<Assess_all_testNmApp_link/>}/> */}

      <Route path="/assess/all/marking" element={<Assess_all_marking/>}/>
      <Route path="/assess/all/marking_stu" element={<Assess_all_marking_stu/>}/>
      <Route path="/assess/all/marking_stu_link" element={<Assess_all_marking_stu_link/>}/>
      <Route path="/assess/assess_link_stu" element={<Assess_link_stu/>}/>

      <Route path="/example" element={<Example/>}/>
      <Route path="/example2" element={<Example2/>}/>

      <Route path="/iongChartApp" element={<IongChartApp/>}/>

      <Route path="/assess_etc_app" element={<Assess_etc_app/>}/>
      <Route path="/assess_etc_checkList_nm" element={<Assess_etc_checkList_nm/>}/>
      <Route path="/assess_book_app" element={<Assess_book_app/>}/>
      <Route path="/assess_book_checkList_nm" element={<Assess_book_checkList_nm/>}/>
      <Route path="/videoEdu" element={<VideoEdu/>}/>
      <Route path="/VideoEdu_stu" element={<VideoEdu_stu/>}/>
      <Route path="/adminsions_consultant" element={<Adminsions_consultant/>}/>

      {/* -----------------------------------------------------------admin */}
      
      <Route path="/ad_adminsions_consultant_app" element={<Ad_adminsions_consultant_app/>}/>
      <Route path="/igongAdmin" element={<Ad_login/>}/>
      <Route path="/ad_menu" element={<Ad_menu/>}/>

      <Route path="/Ujab_write" element={<Ujab_write/>}/>
      <Route path="/ujab_board" element={<Ujab_board/>}/>
      <Route path="/Ujab_detail" element={<Ujab_detail/>}/>

      {/* <Route path="/ad_admissions_consultant_fileDown" element={<Ad_admissions_consultant_fileDown/>}/> */}
      {/* <Route path="/ad_admissions_consultant_app" element={<Ad_admissions_consultant_app/>}/> */}
      {/* <Route path="/ad_admissions_consultant_app_detail" element={<Ad_admissions_consultant_app_detail/>}/> */}
      

      </Routes>
      </Container>
    </div>
  );
}

export default App;
